import { IAssetIncome } from 'models/assets/i-asset-income.interface';

import { useCurrency, useDefaultCurrency } from './useCurrency';
import { useDecimalPrice } from './useDecimalPrice';

export const useMappedIncome = (income?: IAssetIncome | number | null) => {
  const defaultCurrency = useDefaultCurrency();
  const incomeAsAssetIncome = income as IAssetIncome;
  let incomeValue = 0;
  let incomeCurrency = defaultCurrency?.id;

  if (typeof income === 'number') {
    incomeValue = income as number;
  }

  if (incomeAsAssetIncome?.income) {
    incomeValue = incomeAsAssetIncome.income!;
  }

  if (incomeAsAssetIncome?.currency?.id) {
    incomeCurrency = incomeAsAssetIncome?.currency?.id;
  }

  const decimalPrice = useDecimalPrice(incomeValue, incomeCurrency);

  return {
    income: decimalPrice,
    currency: useCurrency(incomeCurrency),
  };
};
